import { useContext, useState } from "react";
import LoaderContext from '../../Context/LoaderContext';
import axios from "axios";
import { useNavigate } from "react-router-dom";

const baseUrl = '/api/v1/';

const useAxios = () => {
    const { setIsLoader } = useContext(LoaderContext);
    const [error, setError] = useState("");
    const [loading, setloading] = useState(false);
    const navigate = useNavigate()

    const fetchData = ({ url, method, body = null }) => {
        setIsLoader(true)
        return new Promise((resolve) => {
            axios[method](baseUrl + url, body)
                .then((res) => {
                    if (res && res.data && res.data.status === 500) {
                        navigate('/login');
                    }
                    resolve(res.data);
                })
                .catch((err) => {
                    setError(err);
                    /* The promise has to settle on failure too. Without this the
                       caller's `await` never returns, so the screen just sits
                       there with no message when a request cannot be made. */
                    const body = err && err.response && err.response.data;
                    if (body && typeof body === 'object') {
                        resolve(body);
                        return;
                    }
                    resolve({
                        status: (err && err.response && err.response.status) || 0,
                        success: false,
                        message: (err && err.message) === 'Network Error'
                            ? 'Cannot reach the server. Check your connection and try again.'
                            : 'Something went wrong please try again',
                        error: err && err.message,
                    });
                })
                .finally(() => {
                    setIsLoader(false);
                });
        })
    }

    return { error, loading, fetchData };

}
export default useAxios;